export enum ClientTypeEnum {
  Male = 1,
  Female = 2,
  Corporation = 3,
}

export enum ClientGenderEnum {
  Male = "1",
  Female = "2",
}

export enum ContracTypeEnum {
  Individual = "0",
  Corporation = "3",
}

export enum ProcedureTypeEnum {
  RepresentativeSelf = "representative",  // 代表者
  ContactPerson = "contact_person",       // 担当者
}

export const CLIENT_GENDER_LABELS = {
  [ClientGenderEnum.Male]: "男性",
  [ClientGenderEnum.Female]: "女性",
} as const satisfies Record<ClientGenderEnum, string>;

export const CONTRACT_TYPE_LABELS = {
  corporation: "法人",
  individual: "個人",
} as const;

export const CLIENT_ADDRESS_LABELS = {
  headOffice: "本店所在地",
  residence: "住所",
} as const;

export const PROCEDURE_TYPE_LABELS = {
  [ProcedureTypeEnum.RepresentativeSelf]: "代表者",
  [ProcedureTypeEnum.ContactPerson]: "担当者",
} as const satisfies Record<ProcedureTypeEnum, string>;

export function getClientGenderLabel(
  gender: ClientGenderEnum | ClientTypeEnum | string | number | undefined
): string | null {
  if (
    gender === ClientGenderEnum.Male ||
    gender === ClientTypeEnum.Male ||
    gender === 1 ||
    gender === "1"
  ) {
    return CLIENT_GENDER_LABELS[ClientGenderEnum.Male];
  }
  if (
    gender === ClientGenderEnum.Female ||
    gender === ClientTypeEnum.Female ||
    gender === 2 ||
    gender === "2"
  ) {
    return CLIENT_GENDER_LABELS[ClientGenderEnum.Female];
  }
  return null;
}

export function isCorporationClientType(
  clientType: ClientTypeEnum | ContracTypeEnum | number
): boolean {
  return (
    clientType === ClientTypeEnum.Corporation ||
    clientType === ContracTypeEnum.Corporation
  );
}

export function getContractTypeLabel(
  clientType: ClientTypeEnum | ContracTypeEnum | number
): string {
  return isCorporationClientType(clientType)
    ? CONTRACT_TYPE_LABELS.corporation
    : CONTRACT_TYPE_LABELS.individual;
}

export function getClientAddressLabel(clientType: ClientTypeEnum | number): string {
  return isCorporationClientType(clientType)
    ? CLIENT_ADDRESS_LABELS.headOffice
    : CLIENT_ADDRESS_LABELS.residence;
}

export function getProcedureTypeLabel(role: ProcedureTypeEnum): string {
  return PROCEDURE_TYPE_LABELS[role];
}

export enum SubscriptionMode {
  Nothing = "nothing",
  MonthlyCancel = "monthly_cancel",
  ContinuousBilling = "continuous_billing",
}

export const getSubscriptionModeLabel = (mode: SubscriptionMode): string => {
  switch (mode) {
    case SubscriptionMode.Nothing:
      return "なし";
    case SubscriptionMode.MonthlyCancel:
      return "月額解約";
    case SubscriptionMode.ContinuousBilling:
      return "継続課金";
    default:
      return mode;
  }
};
